import React from 'react';
import VideoPlayer from '../VideoPlayer';

const YouTubeEmbed = ({ url, roomId }) => (
    <VideoPlayer videoUrl={url} roomId={roomId} />
);

export default YouTubeEmbed;
